import { Controller } from 'stimulus'
import { updateOrderBumps } from '~/site/pages/cart/common'
export default class extends Controller {
  static targets = ['field']
  static values = {
    orderBumpId: Number,
  }

  async toggleOrderBump() {
    this.element.classList.toggle('active')
    this.toggleField()
    updateOrderBumps({
      orderBumpId: this.isActive() ? this.orderBumpIdValue : null,
    })
  }

  isActive() {
    return this.element.classList.contains('active')
  }

  toggleField() {
    this.fieldTarget.disabled = !this.fieldTarget.disabled

    // The code below is for an scenario that is not currently happening, which is having the new order form with order bumps with checkboxes style
    // It is possible that when we start offering/allowing this style,
    // we update the behavior of this style to be the same as clicking the "Add to cart" button (i.e. we'd call checkout_update, reloading the cart)
    // But just in case, this code protects the current behavior from adding the same product as an order bump more than once
    if (!this.fieldTarget.disabled) {
      // disable any other field with the same product id (i.e. any other added order bump of the same product)
      const fields = document.querySelectorAll(
        `[data-product-id="${this.fieldTarget.dataset.productId}"]`
      )
      fields.forEach((field) => {
        if (field == this.fieldTarget) return
        field.disabled = true
        field.closest('.js-order-bump-group').classList.remove('active')
      })
    }
  }
}
